var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('AdminSidebar'),_c('div',{staticClass:"main dashboard"},[_c('AdminNavbar'),_c('main',{staticClass:"content"},[_c('router-view')],1),_c('AdminFooter')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }